import { CandleCountAnimationConfig } from '../../VUE/src/pages/oni-mansion-game/animations/CandleCountAnimationConfig';
import { ClickEffectAnimationConfig } from '../../VUE/src/pages/oni-mansion-game/animations/ClickEffectAnimationConfig';
import { LoadingAnimationConfig } from '../../VUE/src/pages/oni-mansion-game/animations/LoadingAnimationConfig';

export const HousePreviewAnimationConfig = [
  LoadingAnimationConfig,
  ClickEffectAnimationConfig,
  CandleCountAnimationConfig,
];
